module.exports = __webpack_public_path__ + "img/store-outline.e3b27b66.svg";